import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import {
  ContractDocument,
  ContractDocumentPayload,
} from 'types/contract_document'
import { serialize } from 'object-to-formdata'
import { mergeURL } from './lib'

const resource = 'contract_documents'

export const requests = {
  fetchContractDocuments: async (params?: object) => {
    return await axiosForGigbaseBiz.get<DataResponse<ContractDocument[]>>(
      resource,
      { params: params },
    )
  },
  fetchContractDocument: async (id: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<ContractDocument>>(
      mergeURL(resource, `${id}`),
    )
  },
  createContractDocument: async (payload: ContractDocumentPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      resource,
      serialize(payload),
    )
  },
}
